<template>

       <div class="panel">
           <el-form ref="form" :model="rowData" :rules="formRules" label-width="85px">
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="工厂名称" prop="factoryName">
                            <el-input size="small" v-model="rowData.factoryName" placeholder="输入工厂名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用户数" prop="userNum">
                            <el-input size="small" v-model="rowData.userNum" placeholder="请输入用户数" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="有效期" prop="exp">
                          <el-date-picker
                            v-model="rowData.exp"
                            type="datetime"
                            placeholder="选择日期"
                            style="width: 100%;">
                          </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="是否审批">
                            <el-radio-group v-model="rowData.approval">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                  <el-col :span="24">
                    <el-form-item label="是否删除">
                      <el-radio-group v-model="rowData.isDelete">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="联系人" prop="contacts">
                      <el-input size="small" v-model="rowData.contacts" placeholder="输入联系人"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="联系电话" prop="phoneNum">
                      <el-input size="small" v-model="rowData.phoneNum" placeholder="输入联系电话"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="重置密码" prop="phoneNum">
                      <el-input size="small" v-model="rowData.password" placeholder="输入新密码"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
           </el-form>
            <div class="panel-bottom">
                <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
            </div>

       </div>
</template>
<script>
import { positiveIntegerRule} from '@/utils/regMatch';
export default {
    name:'factoryModal',
    props:{

        rowData:{
            type:Object,
            default:{}
        }
    },

    data(){
        return{
            // form:{

            // },
            formRules:{
                factoryName:[
                    { required: true, message: '请输入工厂名称', trigger: 'blur' },
                ],
                userNum:[
                    { required: true, validator: positiveIntegerRule, trigger: 'blur' },
                ]
            },

        }
    },
    created(){

    },
    methods:{
        handleSave(){
            let self = this;
             this.$refs['form'].validate((valid) => {
                if (valid) {
                    self.$emit('save',self.rowData);
                } else {

                }
            });

        },

        closeDialog(){

            setTimeout(() => {
                this.$emit('close');
            }, 100);
        },
    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: 600px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0px 50px;
    }


   .panel-bottom{
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-top: 20px;
      text-align: center;
  }
  .panel-bottom el-button{
      margin: 10px 0 0 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/systemSetting/factorySys/factoryModal.vue